import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { RefreshCw, Sparkles } from 'lucide-react';
import PageShell from '../components/PageShell';
import ApprovalQueue from '../components/ApprovalQueue';
import OperatorInbox from '../components/agent/OperatorInbox';
import { secondaryButtonClass } from '../components/FilterBar';

function Approvals() {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  return (
    <PageShell
      title="Approvals"
      subtitle="Review and approve sensitive actions staged by the AI agent, crypto workflows, and tax filings."
    >
      <div className="flex flex-wrap items-center justify-end gap-2">
        <Link
          to="/ai?rail=approvals"
          className={`${secondaryButtonClass} border-zt-primary/30 text-zt-primary hover:border-zt-primary`}
        >
          <Sparkles size={16} />
          Open in AI Console
        </Link>
        <button type="button" onClick={handleRefresh} className={secondaryButtonClass}>
          <RefreshCw size={16} />
          Refresh
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-3">
        <div className="xl:col-span-2" key={refreshKey}>
          <ApprovalQueue />
        </div>
        <OperatorInbox refreshKey={refreshKey} />
      </div>
    </PageShell>
  );
}

export default Approvals;
